import React from "react"; import jsPDF from "jspdf"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import moment from "moment"; import "bootstrap/dist/css/bootstrap.min.css"; import { useFormik, FormikProvider, Field, ErrorMessage } from "formik"; import { Form, Col, Table } from "react-bootstrap"; import * as OFMSUI from "react-bootstrap"; import { useState } from "react"; import HousingService from "../../../Services/HousingService"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import ReactHTMLTableToExcel from "react-html-table-to-excel"; import { AiOutlineSearch } from "react-icons/ai"; import { useHistory } from "react-router-dom/cjs/react-router-dom.min"; import { Link } from "@material-ui/core"; import CashBankPaymentsNav from './CashBankPaymentsNav'; import CashBankRecNav from './CashBankRecNav'; import JournalVoucherRepNav from './JournalVoucherRepNav'; import ShowAlert from "../../alert"; import { store } from "../../../App";
import { ExportToExcelButton, LabelHeader, ModuleHeaderTitle } from "../../utils/commonFunctions";


const HeadWiseDetails = (props) => {
  const history = useHistory(); const [Headsnmaelist, setHeadsnmaelist] = useState(); const [loading, setLoading] = useState(false); const [tableEnable, settableEnable] = useState(false); const [tabledata, settabledata] = useState(); const [tableEnable1, settableEnable1] = useState(false); const [tableEnable2, settableEnable2] = useState(false); const [tabledata1, settabledata1] = useState([]); const [tabledata2, settabledata2] = useState([]); const [distList, setDistList] = useState(); const [showPay, setShowPay] = useState(false); const [showRec, setShowRec] = useState(); const [showJV, setShowJV] = useState(); const [savefromdate, setfromdate] = useState(); const [savetoate, settoate] = useState(); const [displaydist, setDisplaydist] = useState("All"); const [saveDist, setSaveDist] = useState(""); const [searchText, setSearchText] = useState("");const [saveDistcode, setSaveDistcode] = useState("");

  const todayDate = new Date()
  let year = todayDate.getUTCFullYear()
  let month = todayDate.getMonth() + 1
  let tDate = todayDate.getDate()
  if (month < 10) { month = '0' + month }
  if (tDate < 10) { tDate = '0' + tDate }

  const maxDate = year + '-' + month + '-' + tDate

  const CustomDateComponent = props => (
    <input className='my-custom-input' type='date' maxDate={maxDate} {...props} />
  )
  const today = new Date()
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth() + 1
  const firstDayOfMonth = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-01`

  React.useEffect(() => {
    HousingService.headsNameApi().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (<option key={i} value={item.headid}> {item.heads} </option>);
          }
        });
        setHeadsnmaelist(options);
      }
    });
    HousingService.CGG_District().then(res => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (<option key={i} value={item.code}>{item.name}</option>)
        })
        setDistList(options)
      }
    })
  }, [])
  const formik = useFormik({
    initialValues: {
      fromDate: firstDayOfMonth,
      toDate: today.toISOString().substr(0, 10),
      headid: 'All',
      district: ""
    },
    validate: values => {
      const errors = {}
      if (!values.fromDate) { errors.fromDate = 'From Date is required' }
      if (!values.toDate) { errors.toDate = 'To Date is required' }
      if (!values.district) { errors.district = 'District is required' }
      if (values.fromDate && values.toDate && values.fromDate > values.toDate) { errors.toDate = 'To Date must be greater than From Date' }
      return errors
    },
    onSubmit: async (values) => {
      let params = {
        fromDate: moment(formik.values.fromDate).format("DD-MM-YYYY"),
        toDate: moment(formik.values.toDate).format("DD-MM-YYYY"),
        headid: formik.values.headid,
        security_id: formik.values.district,
      };
      setSaveDistcode(formik.values.district);
      console.log(formik.values.district);
      setfromdate(formik.values.fromDate)
      settoate(formik.values.toDate)
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (formik.values.headid === "All") {
        HousingService.headerwisetabledata(params).then((res) => { settabledata(res.data); setDisplaydist(res.data[0].district); setSaveDist(res.data[0].district); settableEnable(true); settableEnable1(false); settableEnable2(false); setShowPay(false); setShowJV(false); setShowRec(false); });
      }
      else {
        HousingService.headerwisetabledata(params).then((res) => { settabledata1(res.data); setDisplaydist(res.data[0].district); setSaveDist(res.data[0].district); settableEnable(false); settableEnable1(true); settableEnable2(false); setShowPay(false); setShowJV(false); setShowRec(false); })
      }
      setLoading(false);
    },
  })
  const paymentCountClick = () => { settableEnable(false); settableEnable1(false); settableEnable2(false); setShowPay(true); setShowRec(false); setShowJV(false); };
  const receiptsCountClick = () => { settableEnable(false); settableEnable1(false); settableEnable2(false); setShowPay(false); setShowRec(true); setShowJV(false); }
  const jvCountClick = () => { settableEnable(false); settableEnable1(false); settableEnable2(false); setShowPay(false); setShowRec(false); setShowJV(true); }
  const goBack = () => { if (tableEnable1 || showPay || showJV || showRec) { settableEnable(true); settableEnable1(false); settableEnable2(false); setShowJV(false); setShowPay(false); setShowRec(false); } else { history.goBack(); } }

  function table() {
    const pageWidth = 210; const pageHeight = 297; const imgPath = "/img/APSHCL_logo.png"; const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight], });


    const fromDate = moment(formik.values.fromDate).format("DD//MM/YYYY"); const toDate = moment(formik.values.toDate).format("DD//MM/YYYY"); const distuser = localStorage.getItem("username"); const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)"; const headingText3 = `Head Wise  Report of ${displaydist} from : ${fromDate}  to : ${toDate} User: ${distuser} `; const headingText4 = "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007"; const fontSize = 12; const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor; const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2; doc.setFont("times new roman"); const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor; const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor; const tableYStart = 35; doc.setFontSize(fontSize); const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2; doc.text(headingText2, xCoordinate2, 10); const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2; doc.text(headingText3, xCoordinate3, 30); doc.text(headingText4, xCoordinate4, 20); doc.addImage(imgPath, "PNG", 5, 5, 25, 25);

    doc.autoTable({
      html: "#my-table",
      theme: "striped",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 8,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("HeadWiseReport.pdf");
  }
  function table1() {
    const pageWidth = 210;
    const pageHeight = 297;
    const imgPath = "/img/APSHCL_logo.png";
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight],
    });

    const fromDate = moment(formik.values.fromDate).format("DD//MM/YYYY");
    const toDate = moment(formik.values.toDate).format("DD//MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = `Head Wise  Report of ${displaydist} from : ${fromDate}  to : ${toDate} User: ${distuser} `;
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";

    const fontSize = 12;

    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2;

    doc.setFont("times new roman");

    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;

    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;

    const tableYStart = 35;

    doc.setFontSize(fontSize);

    const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2;


    doc.text(headingText2, xCoordinate2, 10);


    const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2;


    doc.text(headingText3, xCoordinate3, 30);
    doc.text(headingText4, xCoordinate4, 20);

    doc.addImage(imgPath, "PNG", 5, 5, 25, 25);

    doc.autoTable({
      html: "#my-table1",
      theme: "striped",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 8,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("HeadWiseReport.pdf");
  }
  function table2() {
    const pageWidth = 500;
    const pageHeight = 250;
    const imgPath = "/img/APSHCL_logo.png";
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight],
    });

    const fromDate = moment(formik.values.fromDate).format("DD//MM/YYYY");
    const toDate = moment(formik.values.toDate).format("DD//MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = `Head Wise  Report of ${displaydist} from : ${fromDate}  to : ${toDate} User: ${distuser} `;
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";

    const fontSize = 8;

    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const xCoordinate4 = (pageWidth * 1 - textWidth4) / 2;



    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;

    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;

    const tableYStart = 35;

    doc.setFontSize(fontSize);

    const xCoordinate2 = (pageWidth * 1 - textWidth2) / 2;


    doc.text(headingText2, xCoordinate2, 10);


    const xCoordinate3 = (pageWidth * 1 - textWidth3) / 2;


    doc.text(headingText3, xCoordinate3, 30);
    doc.text(headingText4, xCoordinate4, 20);

    doc.addImage(imgPath, "PNG", 5, 5, 25, 25);

    doc.autoTable({
      html: "#my-table2",
      theme: "striped",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 8,
      },
      columnWidth: {
        0: 15,
        1: 30,
        2: 30,
        3: "auto",
        4: 30,
        5: 30,
      },
    });

    doc.save("HeadWiseReport.pdf");
  }
  const countClick = (transaction_type) => {
    if (transaction_type === "P" || transaction_type === "R") {
      store.dispatch({ type: "SHOW_SPINNER" })
      let params = { "fromDate": moment(formik.values.fromDate).format("DD-MM-YYYY"), "toDate": moment(formik.values.toDate).format("DD-MM-YYYY"), "transaction_type": transaction_type, "security_id": formik.values.district, "headid": formik.values.headid }
      console.log(params)
      HousingService.GetCashBank_Receipts_PaymentsReportheadwise(params).then((res) => {
        if (res.data) {
          settabledata2(res.data)
          console.log(res.data)
          settableEnable(false);
          settableEnable1(false);
          settableEnable2(true);
          setShowPay(false);
          setShowRec(false);
          setShowJV(false);
          store.dispatch({ type: "HIDE_SPINNER" })
        }
        else {
          store.dispatch({ type: "HIDE_SPINNER" })
          ShowAlert("Some Error Occurred", "error")
        }
      }).finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" })
      })
    }
    if (transaction_type === "J") {
      store.dispatch({ type: "SHOW_SPINNER" })
      let params = { "fromDate": moment(formik.values.fromDate).format("DD-MM-YYYY"), "toDate": moment(formik.values.toDate).format("DD-MM-YYYY"), "security_id": formik.values.district, "headid": formik.values.headid }
      HousingService.GetCashBank_All_JV_Reportheadwise(params).then((res) => {
        if (res.data) {
          settabledata2(res.data)
          console.log(res.data)
          settableEnable(false);
          settableEnable1(false);
          settableEnable2(true);
          setShowPay(false);
          setShowRec(false);
          setShowJV(false);
          store.dispatch({ type: "HIDE_SPINNER" })
        }
        else {
          store.dispatch({ type: "HIDE_SPINNER" })
          ShowAlert("Some Error Occurred", "error")
        }
      }).finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" })
      })
    }

  };



  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };
  const filteredData2 =
    searchText.length > 0
      ? tabledata2?.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => {
            const value = item[key];
            return (
              value !== null &&
              value
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
            );
          })
        );
      })
      : tabledata2;
  const getPdf = payment_receipt_id => {
    console.log("p", payment_receipt_id)
    if (payment_receipt_id && payment_receipt_id.charAt(0) != "P") {
      HousingService.getPaymentPdf(payment_receipt_id).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        let tab = window.open();
        tab.location.href = url;
      });
    }
    else {
      HousingService.getjournalpdf(payment_receipt_id).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        let tab = window.open();
        tab.location.href = url;
      });
    }
  }

  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <ModuleHeaderTitle title="Head Wise Details" />
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='page-titlespacing' > <button className='btn btn-primary'
            style={{ textAlign: 'right', float: 'right', marginTop: '17px', backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type='reset'
            onClick={() => goBack()} > Back </button>
          </OFMSUI.Col> </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className='outer-page-content-container' fluid style={{ width: "90%" }} >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className=''> <LabelHeader title="From Date" /> <Field name='fromDate' className={formik.touched.fromDate && formik.errors.fromDate ? 'form-control is-invalid' : 'form-control'} type='date' onChange={e => formik.handleChange(e)} as={CustomDateComponent} max={maxDate} /> {formik.touched.fromDate && formik.errors.fromDate ? (<div className='invalid-feedback'> {formik.errors.fromDate} </div>) : null} </Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className=''><LabelHeader title="To Date" />  <Field name='toDate' className={formik.touched.toDate && formik.errors.toDate ? 'form-control is-invalid' : 'form-control'} type='date' onChange={e => formik.handleChange(e)} as={CustomDateComponent} max={maxDate} /> {formik.touched.toDate && formik.errors.toDate ? (<div className='invalid-feedback'>{formik.errors.toDate}</div>) : null} </Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className=''> <LabelHeader title="Heads name" /><Field name='headid' className={formik.touched.headid && formik.errors.headid ? 'form-control is-invalid' : 'form-control'} onChange={e => formik.handleChange(e)} component='select' > <option value='All'>ALL</option> {Headsnmaelist} </Field> {formik.touched.headid && formik.errors.headid ? (<div className='invalid-feedback'>{formik.errors.headid}</div>) : null} </Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}><LabelHeader title="District" />  <Field component='select' name='district' className={formik.touched.district && formik.errors.district ? 'form-control is-invalid' : 'form-control'} onChange={e => formik.handleChange(e)} > {formik.touched.district && formik.errors.district ? (<div className='invalid-feedback'> {formik.errors.district} </div>) : null} <option value=''>Select</option> {distList} </Field> <ErrorMessage name="district" component={"div"} className="text-error" /> </Col>
            </OFMSUI.Row>
            &nbsp;
            <OFMSUI.Row> <center> {" "} {loading ? (<div className="d-flex justify-content-center"> <button className="btn btn-primary" type="button"> <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" ></span> ....Loading </button> </div>) : (<center> {" "} <button className="btn btn-primary" type="submit"> Submit </button> </center>)} </center> </OFMSUI.Row>
            &nbsp;
            {showPay && (
              <CashBankPaymentsNav savefromdate={savefromdate} savetoate={savetoate} saveDist={saveDist} saveDistcode={saveDistcode}/>)} 
              {showRec && (
              <CashBankRecNav savefromdate={savefromdate} savetoate={savetoate} saveDist={saveDist} saveDistcode={saveDistcode} />)} {showJV && (
              <JournalVoucherRepNav savefromdate={savefromdate} savetoate={savetoate} saveDist={saveDist}  saveDistcode={saveDistcode} />)}
            {tableEnable && (
              <>
                <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mb-2 float-end" >
                  <ExportToExcelButton tableId="my-table" filename="HeadwiseDetails" sheet="tablexls" buttonText="Excel" />
                  <button className="btn btn-danger btn-sm" onClick={table} type='button' style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col> </OFMSUI.Row>
                <Table striped bordered hover id="my-table">
                  <thead className="fw-bold">
                    <tr className="text-center"><td colSpan={9}>Receipts, Payments and JV's for {displaydist} between{" "} {moment(formik.values.fromDate).format("DD-MM-YYYY")} and {moment(formik.values.toDate).format("DD-MM-YYYY")}</td></tr>
                    <tr className="table_countshead"> <th>S No.</th> <th>District</th> <th>No. of Payments</th> <th>Debit</th> <th>No. of Receipts</th> <th>Credit</th> <th>No. of Journal Vouchers</th> <th>JV Debit</th> <th>JV Credit</th> </tr> </thead>
                  <tbody> {tabledata && tabledata.length > 0 ? (tabledata.map((item, i) => (<tr key={i}> <td>{i + 1}</td> <td>{item.district}</td> <td> <Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => paymentCountClick()}>{item.payment_count}</Link></td> <td>{item.payment_total}</td> <td><Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => receiptsCountClick()}>{item.receipt_count}</Link></td> <td>{item.receipt_total}</td> <td><Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => jvCountClick()}>{item.jv_count}</Link></td> <td>{item.jv_credit}</td> <td>{item.jv_debit}</td> </tr>))) : (<tr> <td colSpan={9} style={{ textAlign: "center" }}>No data found</td> </tr>)} </tbody>
                </Table>
              </>
            )}
            {tableEnable1 && (
              <>
                <OFMSUI.Row> <center> {" "} <h5 style={{ fontFamily: "times new roman", color: "black" }}> {" "} Receipts,Payments and JV's for Selected Head ID-"{formik.values.headid}"{" "} of {displaydist} between {moment(formik.values.fromDate).format("DD-MM-YYYY")} and {moment(formik.values.toDate).format("DD-MM-YYYY")}{" "} </h5> </center> </OFMSUI.Row>
                <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mb-2 float-end" > <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} > <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table1" filename="HeadWiseReport" sheet="tablexls" buttonText="Excel" ></ReactHTMLTableToExcel> </button> <button className="btn btn-danger btn-sm" onClick={table1} type='button' style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col> </OFMSUI.Row>
                <Table striped bordered hover id="my-table1">
                  <thead className="fw-bold"> <tr className="table_countshead"> <th>S No.</th> <th>District</th> <th>No. of Debits</th> <th>Debit</th> <th>No. of Credits</th> <th>Credit</th> <th>No. of Journal Vouchers</th> <th>J.V. Credit</th> <th>J.V. Debit</th> </tr> </thead>
                  <tbody> {tabledata1 && tabledata1.length > 0 ? (tabledata1.map((data, i) => (<tr key={i}> <td>{i + 1}</td> <td>{data.district}</td> <td> <Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => countClick("P")}>{data.count_payments}</Link></td> <td>{data.amount_payments}</td> <td> <Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => countClick("R")}>{data.count_receipts}</Link></td> <td>{data.amount_receipts}</td> <td> <Link style={{ cursor: "pointer", textDecoration: "none" }} onClick={() => countClick("J")}>{data.jv_count}</Link></td> <td>{data.jv_credit}</td> <td>{data.jv_debit}</td> </tr>))) : (<tr> <td colSpan={9} style={{ textAlign: "center" }}>No data found</td> </tr>)} </tbody>
                  <tfoot> <tr > <td colSpan={2} style={{ textAlign: "end" }}> Total  </td> <td>{tabledata1.reduce((a, v) => a + v.count_payments, 0)}</td> <td>{tabledata1.reduce((a, v) => a + v.amount_payments, 0)}</td> <td>{tabledata1.reduce((a, v) => a + v.count_receipts, 0)}</td> <td>{tabledata1.reduce((a, v) => a + v.amount_receipts, 0)}</td> <td>{tabledata1.reduce((a, v) => a + v.jv_count, 0)}</td> <td>{tabledata1.reduce((a, v) => a + v.jv_credit, 0)}</td> <td>{tabledata1.reduce((a, v) => a + v.jv_debit, 0)}</td> </tr> </tfoot>
                </Table>
              </>
            )}
            {tableEnable2 && (
              <>
                <OFMSUI.Row> <center> {" "} <h5 style={{ fontFamily: "times new roman", color: "black" }}> {" "} Receipts,Payments and JV's for Selected Head ID-"{formik.values.headid}"{" "} of {displaydist} between {moment(formik.values.fromDate).format("DD-MM-YYYY")} and {moment(formik.values.toDate).format("DD-MM-YYYY")}{" "} </h5> </center> </OFMSUI.Row>
                <OFMSUI.Row>
                  <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                    <div className="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div> <input type="text" id="#filterInput" placeholder="Search " style={{ width: "25%" }} className="form-control input-lg" value={searchText} onChange={handleSearch} ></input> </div>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      style={{
                        float: "right",
                        color: "#fff",
                        marginLeft: "3px"
                      }}
                    >
                      <ReactHTMLTableToExcel
                        id="my-table-xls-button"
                        className="download-table-xls-button"
                        table="my-table2"
                        filename="CBPayments"
                        sheet="tablexls"
                        buttonText="Excel"
                      />
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={table2}
                      style={{ float: "right", marginLeft: "3px" }}
                      type="button"
                    >
                      PDF
                      <MdOutlinePictureAsPdf />
                    </button>

                  </OFMSUI.Col>
                </OFMSUI.Row>
                <Table striped bordered hover id="my-table2">
                  <thead className="fw-bold">
                    <tr className="table_countshead">
                      <th>S No.</th>
                      <th>Transaction ID</th>
                      <th>Date</th>
                      <th>Voucher No.</th>
                      <th>Description</th>
                      <th style={{ width: "120px" }}>Debit</th>
                      <th style={{ width: "120px" }}>Credit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData2 && filteredData2.length > 0 ? (filteredData2.map((data, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td onClick={() => { getPdf(data.payment_receipt_id) }} > <Link>{data.payment_receipt_id}</Link> </td>
                        <td>{data.date}</td>
                        <td>{data.receiptno || data.voucher_id || 0}</td>
                        <td>{data.receipt_description || data.description || 0}</td>
                        {data.transaction_type == "P" && (<> <td>{data.paymentamount}</td> <td>{data.receiptamount}</td> </>)}
                        {data.transaction_type == "R" && (<> <td>{data.paymentamount}</td> <td>{data.receiptamount}</td> </>)}
                        {data.payment_receipt_id.startsWith("J") && (<> <td>{data.debith || 0}</td> <td>{data.credith || 0}</td> </>)}
                      </tr>
                    ))
                    ) : (
                      <tr>
                        <td colSpan={9} style={{ textAlign: "center" }}>No data found</td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={5} style={{ textAlign: "end" }}> Total </td>
                      <td>
                        {filteredData2.reduce((a, v) => {
                          if (v.transaction_type === "P" || v.transaction_type === "R") {
                            return a + (v.paymentamount || 0);
                          } 
                          else if (v.payment_receipt_id.startsWith("J")) {
                            return a + (v.debith || 0);
                          }
                          return a;
                        }, 0)}
                      </td>
                      <td>
                        {filteredData2.reduce((a, v) => {
                          if (v.transaction_type === "P" || v.transaction_type === "R") {
                            return a + (v.receiptamount || 0);
                          } else if (v.payment_receipt_id.startsWith("J")) {
                            return a + (v.credith || 0);
                          }
                          return a;
                        }, 0)}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  )
}

export default HeadWiseDetails